import { ActionBase } from ".";

export class SaveAction extends ActionBase {

}